export default "__VITE_ASSET__LIoI8Jjf__"